import React, { useEffect } from 'react'
import GenerateIcon, { IconTypes } from '../../components/GenerateIcon'
import TransactionsApp from './TransactionsApp'

interface IProps {
    selectedType: string,
    selectedAction: string,
    handleSelectedType: (type: string) => void,
    useRequestsTypes?: boolean,
    isOrigin?: boolean,
}

interface ITransactionType {
    type: string,
    label: string,
    icon: IconTypes
}

export function SelectTransactionFromType(props: IProps) {

    const { selectedType, handleSelectedType, selectedAction, isOrigin } = props

    const transactionsApp = new TransactionsApp()

    const items: Array<ITransactionType> = [
        {
            type: "to-warehouse",
            label: isOrigin ? "Warehouse" : transactionsApp.returnFromTypeBasedOnAction(selectedAction, true) + " a warehouse",
            icon: "inventory"
        },
        {
            type: "to-section",
            label: isOrigin ? "Section" : transactionsApp.returnFromTypeBasedOnAction(selectedAction, true) + " a section",
            icon: "folder"
        },
        {
            type: "to-location",
            label: isOrigin ? "Location" : transactionsApp.returnFromTypeBasedOnAction(selectedAction, true) + " a location",
            icon: "map"
        },
        {
            type: "with-user",
            label: isOrigin ? "User" : "From User",
            icon: "user"
        }
    ]

    const renderSingleItem = (item: ITransactionType, index: number) => {

        return(
            <div onClick={() => handleSelectedType(item.type)} className={item.type == selectedType ? "single-transaction-type-item active" : "single-transaction-type-item"} key={index}>
                <div className="content-of-single-transaction-type-item">

                    <GenerateIcon icon={item.icon} />

                    <h3>{item.label}</h3>

                </div>
            </div>
        )
    }


    return(
        <div className="select-types-container">
            <div className="content-of-select-types-container">
                {items.map((item, index) => renderSingleItem(item, index))}
            </div>
        </div>
    )
}

export default function SelectTransactionType(props: IProps) {

    const { selectedType, handleSelectedType, selectedAction, useRequestsTypes } = props

    const transactionsApp = new TransactionsApp()

    const items: Array<ITransactionType> = !useRequestsTypes ? [
        {
            type: "to-warehouse",
            label: transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a warehouse",
            icon: "inventory"
        },
        {
            type: "to-section",
            label: transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a section",
            icon: "folder"
        },
        {
            type: "to-location",
            label: transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a location",
            icon: "map"
        },
        {
            type: "with-user",
            label: selectedAction == "taken" ? "Give to User" : transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a user",
            icon: "user"
        }
    ] : [
        {
            type: "warehouse",
            label: transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a warehouse",
            icon: "inventory"
        },
        {
            type: "location",
            label: transactionsApp.returnTypeBasedOnAction(selectedAction, true) + " a location",
            icon: "map"
        },
        {
            type: "user",
            label: "Give to User",
            icon: "user"
        }
    ]

    const renderSingleItem = (item: ITransactionType, index: number) => {

        const returnClassName = (name: string) => {

            if (selectedAction === "move"){
                if (item.type === "with-user" || item.type === "user"){
                    return name + " disabled"
                }
            }

            return name
        }

        return(
            <div onClick={() => handleSelectedType(item.type)} className={item.type == selectedType ? returnClassName("single-transaction-type-item active") : returnClassName("single-transaction-type-item")} key={index}>
                <div className="content-of-single-transaction-type-item">

                    <GenerateIcon icon={item.icon} />

                    <h3>{item.label}</h3>

                </div>
            </div>
        )
    }


    return(
        <div className="select-types-container">
            <div className="content-of-select-types-container">
                {items.map((item, index) => renderSingleItem(item, index))}
            </div>
        </div>
    )
}